import { render, staticRenderFns } from "./MessageBoard.vue?vue&type=template&id=f0c47a0e&scoped=true"
import script from "./MessageBoard.vue?vue&type=script&lang=js"
export * from "./MessageBoard.vue?vue&type=script&lang=js"
import style0 from "./MessageBoard.vue?vue&type=style&index=0&id=f0c47a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c47a0e",
  null
  
)

export default component.exports